import React from 'react';
import { useFetchSelfServiceCorporateData } from 'src/components/selfService/common/SelfServiceCorporateData/hooks/useFetchSelfServiceCorporateData';
import { SelfServiceCorporateDataContext } from 'src/components/selfService/common/SelfServiceCorporateData/SelfServiceCorporateDataContext';

interface SelfServiceCorporateDataProviderProps {
  corpId: string;
}

export const SelfServiceCorporateDataProvider: React.FC<SelfServiceCorporateDataProviderProps> =
  ({ corpId, children }) => {
    const { corpData, isLoading, hasError, refetch } =
      useFetchSelfServiceCorporateData({
        corpId,
      });

    return (
      <SelfServiceCorporateDataContext.Provider
        value={{ corpData, isLoading, hasError, refetch }}
      >
        {children}
      </SelfServiceCorporateDataContext.Provider>
    );
  };
